import React from "react";
import { motion } from "framer-motion";
import { Calendar, Users, TrendingUp, Shield } from "lucide-react";
import { Card, CardContent } from "../ui/card";

const Features = () => {
    
  const features = [
    {
      title: "Dedicated BIPOC Community",
      description: "Connect with clients who are specifically seeking culturally competent care in a supportive environment.",
      icon: <Users className="h-10 w-10 text-primary" />
    },
    {
      title: "Seamless Practice Management",
      description: "Schedule appointments, conduct secure video sessions, and manage client records all in one platform.",
      icon: <Calendar className="h-10 w-10 text-primary" />
    },
    {
      title: "Grow Your Practice",
      description: "Increase your visibility within the BIPOC community and receive qualified client referrals.",
      icon: <TrendingUp className="h-10 w-10 text-primary" />
    },
    {
      title: "HIPAA Compliant",
      description: "Our platform adheres to all required healthcare privacy regulations to protect you and your clients.",
      icon: <Shield className="h-10 w-10 text-primary" />
    }
  ];

  return(
    <section className="py-20">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4">Why Join MindPulse Therapy?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our platform helps therapists like you provide essential mental health services to underserved communities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full border-none shadow-lg hover:shadow-xl transition-shadow">
                <CardContent className="pt-6">
                  <div className="mb-5">{feature.icon}</div>
                  <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features;